import { useClientSideTranslation } from 'src/services/i18n'
import AngleLeftIcon from 'src/app/assets/icons/ico-angle-left.svg'
import FlagCheckeredIcon from 'src/app/assets/icons/ico-flag-checkered.svg'
import { useGetCurrentLanguage } from 'src/store/game'
import { PastRacesSidebar } from 'src/components/PastRacesSidebar'

type Props = Readonly<{
  onBackClick: () => void
}>

export function PastRacesPanel({ onBackClick }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())

  return (
    <div>
      <div className="panel-header">
        <button className="back" onClick={onBackClick} type="button">
          <span className="icon">
            <AngleLeftIcon />
          </span>
        </button>
        <FlagCheckeredIcon />
        <span>{t('Past Games')}</span>
      </div>
      <PastRacesSidebar />
    </div>
  )
}
